export class Seniority {
  PrefixName: string;
  PrefixID: number;
  IsActive: boolean
}